import React from 'react';
import '../styles/projects.scss';
import projects from './project-data';
import { ProjectTile } from './project-grid';

// Index at /projects: every project as a 4-wide grid.
export const ProjectIndex = () => {
  return (
    <div className="project-page">
      <div className="project-index-grid">
        {projects.map((p) => <ProjectTile key={p.slug} project={p} />)}
      </div>
    </div>
  );
};

// Shared layout for every project page: tile strip, title, date, writeup.
const ProjectPage = ({ match }) => {
  const project = projects.find((p) => p.slug === match.params.slug);
  if (!project) {
    return <div>Project not found</div>;
  }
  return (
    <div className="project-page">
      <div className="project-strip">
        {projects.map((p) => <ProjectTile key={p.slug} project={p} />)}
      </div>
      <article className="project-body">
        <h1>{project.title}</h1>
        <h3 className="project-date">{project.date}</h3>
        {(project.link || project.pdf) && (
          <p className="project-link">
            {project.link && <a href={project.link} target="_blank" rel="noreferrer">{project.link.replace('https://', '')}</a>}
            {project.link && project.pdf && ' · '}
            {project.pdf && <a href={project.pdf} target="_blank" rel="noreferrer">PDF</a>}
          </p>
        )}
        {project.body}
      </article>
    </div>
  );
};

export default ProjectPage;
